import React, { useEffect, useState } from 'react'
import "./clock.css"
import ModalClock from './modalClock'
import { formatHourMinute, getZonedParts } from '../../utils/timezone'


export default function Clock({date, requestedDate, setHour, setError, openModal, setOpenModal}) {
  const [value, setValue] = useState()
  const [hourModal, setHourModal] = useState("__")
  const [minutes, setMinutes] = useState("__")


  useEffect(() => {
    if (!requestedDate) return
    const [h, m] = formatHourMinute(requestedDate).split(":")
    setHourModal(h)
    setMinutes(m)
  }, [requestedDate])

  useEffect(() => {
    setValue(hourModal + ":" + minutes)
  }, [hourModal,minutes])

     useEffect(() => {
    const now = requestedDate ? getZonedParts(requestedDate) : null
    if( now && date.getMonth() == now.month &&
        date.getDate() == now.day){
          if(  formatHourMinute(requestedDate) > hourModal + ":" + minutes)
              {
                  setError(true)
               } else {
                setError(false)
                setHour(value)
               }
        }else{
          setError(false)
          setHour(value)
        }

  },[value, date.getDate(), date.getMonth()])

  return (
    <div className='clock-div' onClick={(e) => {e.stopPropagation();setOpenModal(!openModal)}}>
      <input value={value} disabled required/>
      <div>
        <img src="/475669.png"  />
        {openModal && <ModalClock setHour={setHourModal} setMinutes={setMinutes}/> }
      </div>
    </div>
  );
}
